// extracted by mini-css-extract-plugin
module.exports = {"modal":"_dose-reductions_modal__RV9A8","container":"_dose-reductions_container__dfuFx"};